<div class="who-are-we-wrapper">
  <div class="header">
    <div class="title pt-5 pb-4">
      {{ info.title }}
    </div>
    <div class="sub-title pb-3">
      {{ info.subTitle }}
    </div>
    <div class="desc pb-5">
      {{ info.desc }}
    </div>
  </div>

  <div class="floating-section">
    <div class="card" *ngFor="let item of floatingInfo; index as i">
      <div class="icon">
        <img data-src="{{ 'assets/images/sip/icons/'+ item.icon + '.png' }}" loading="lazy" alt="">
      </div>
      <div class="stats mt-3">
        {{ item.stats }}
      </div>
      <div class="text mt-1">
        {{ item.text }}
      </div>
    </div>
  </div>
</div>
